export default __webpack_public_path__ + "static/media/pluse-icon.d7393b58.svg";